import * as React from "react";
import { UitkCard, UitkCardLink, UitkCardTextSegment } from "uitk-react-cards";
import {
  PageBackgroundContext,
  BackgroundColorTokens,
} from "src/components/flexComponents/PageLevelProviders/PageBackgroundColor/PageBackgroundContext.tsx";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkText, UitkTextProps } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import TruncatedText from "shiitake";

export interface CardProps {
  id: string;
  title: string;
  line1: string;
  line2: string;
  deepLinkUrl: string;
  icon: string;
}

export const Card: React.FunctionComponent<CardProps> = ({ title, line1, line2, deepLinkUrl, icon }) => {
  const backgroundColor = React.useContext(PageBackgroundContext);
  const withBorder = backgroundColor === BackgroundColorTokens.BACKGROUND_WHITE;
  const textConfig: UitkTextProps = { size: 300, spacing: "two" };
  const maxTitleLines = 2;
  const a11yLinkText = `${title + line1 + line2}`;

  return (
    <>
      <UitkCard withBorder={withBorder}>
        <UitkLayoutFlex direction="row" alignItems="center" className="all-l-padding-three">
          <div className="circleContainer all-x-padding-two all-y-padding-two all-r-margin-two">
            <UitkIcon name={icon} size={UitkIconSize.MEDIUM} />
          </div>
          <UitkCardTextSegment>
            <TruncatedText renderFullOnServer={true} lines={maxTitleLines} className="uitk-type-heading-400">
              {title}
            </TruncatedText>
            <UitkText size={textConfig.size} spacing={textConfig.spacing}>
              {line1}
            </UitkText>
            <UitkText size={textConfig.size}>{line2}</UitkText>
          </UitkCardTextSegment>
        </UitkLayoutFlex>
        <UitkCardLink>
          <a href={deepLinkUrl}>{a11yLinkText}</a>
        </UitkCardLink>
      </UitkCard>
    </>
  );
};
